module.exports = "https://cdn.thelire.com/ins/resource/ico_feed_watchearn@3x.ce51563ef5b716e2b76026c71b9693b0.png";